// src/common/hooks/DialogContext.js
import React, { createContext, useCallback, useContext, useState } from 'react';

const DialogContext = createContext();

export const DialogProvider = ({ children }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [opacity, setOpacity] = useState(0);

  const openModal = useCallback(() => {
    setIsOpen(true);

    setTimeout(() => setOpacity(1), 100);
  }, []);

  const closeModal = useCallback(() => {
    setOpacity(0);
    setTimeout(() => setIsOpen(false), 300);
  }, []);

  return (
    <DialogContext.Provider
      value={{ isOpen, opacity, openModal, closeModal, setOpacity, setIsOpen }}
    >
      {children}
    </DialogContext.Provider>
  );
};

export const useDialog = () => {
  const context = useContext(DialogContext);
  if (!context) {
    throw new Error('useDialog must be used within a DialogProvider');
  }
  return context;
};
